import axios from "axios";
import AppConfig from "appConfig";

const axiosInstance = axios.create();
axiosInstance.defaults.baseURL = AppConfig.api_base_url;
axiosInstance.defaults.headers.common.token = localStorage.getItem(AppConfig.auth_token);

axiosInstance.interceptors.response.use(
  (response) => {
    // console.log(response.data.inbox);
    AppConfig.newInbox = response.data.inbox;
    AppConfig.profile_reqd = response.data.profile_reqd;
    return response;
  },
  (error) => Promise.reject((error.response && error.response.data) || "Something went wrong!")
);

export default axiosInstance;
